import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { BtnForm } from "../../general/BotonesAccion";
import AppBarModal from '../../general/AppBarModal'
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { obtenerValoresFiltros, transformar,consulta } from "../../../global/js/funciones";
import BuscarSelect from '../../general/BuscarSelect';
import BuscarPersona from '../../general/BuscarPersona';
import InputBuscar from '../../general/InputBuscar';
import TareasTerminadas from "../../general/TareasTerminadas";
import emma_w from '../../../global/imagenes/emma_w.png';
import {ESTADOS} from '../Helpers';


class RetoFiltrar extends Component {

  constructor(props) {
    super(props)
    this.state = {
      estados: [],
      estado: null,
      periodo: null,
      cargando: true,
      cargar: true,
    }
  }

  obtenerPeriodos = () => {
    return new Promise(resolve => {
        consulta(`api/v1.0/retoscuc/periodos`, null, null,
            (error, estado, resp) => {
                resolve(resp)
            }
        );
    })
  }

  async componentDidUpdate({ ModalAddFiltrosRetos, accionProceso }) {
    let { ModalAddFiltrosRetos: ModalAddFiltrosRetosNew, accionProceso: accionProcesoNew } = this.props;
    if (ModalAddFiltrosRetos !== ModalAddFiltrosRetosNew && this.state.cargar) {
      this.setState({ cargando: true })
      let estados = await obtenerValoresFiltros([{ 'llave': 'generica', 'valor': ESTADOS}]);
      let periodos = await this.obtenerPeriodos();
      this.setState({
        'estados': transformar(estados),
        'periodos': transformar(periodos, 'periodo', 'periodo'),
        cargando: false,
        cargar: false
      })
    }

    if (accionProceso != accionProcesoNew && accionProceso != 'inicio') {
      this.setState({
        estado: null,
        busca_empresa: '',
        trabaja: '',
        per: '',
        estudiante: {
          id: 0,
          nombre: ''
        }
      })
    }
  }

  onChange = ({ target }) => {
    let { value, name } = target;
    this.setState({
      [name]: value
    })
  }

  changeState = (estados) => {
    this.setState(estados)
  }

  resetState = () => {
    let { limpiar, mostrarModalAddFiltrosRetos } = this.props;
    this.setState({
      estado: null,
      per: '',
    })
    limpiar();
    mostrarModalAddFiltrosRetos(false)
  }

  onSubmit = e => {
    let { filtrar, actualizarMensaje, accionProceso, mostrarTodos, mostrarModalAddFiltrosRetos } = this.props;
    let {
      periodo,
      estado,
    } = this.state;
    let filtros = [];
    if (periodo !== null) filtros.push({ 'llave': 'periodo', 'valor': periodo.value });
    if (estado !== null) filtros.push({ 'llave': 'estado_actual', 'valor': estado.value });
    if (filtros.length > 0){
      if (accionProceso == 'inicio') mostrarTodos('Tod_Ret')
        mostrarModalAddFiltrosRetos(false)
      console.log(filtros)
      filtrar(filtros);
    } else actualizarMensaje({ titulo: 'Seleccione Algún filtro', estado: 'info', mostrar: true, tiempo: 6000 });
    e.preventDefault();
  }

  render() {
    let { ModalAddFiltrosRetos, mostrarModalAddFiltrosRetos, accionProceso } = this.props;
    let {
      periodo,
      estado,
      estados,
      periodos,
      cargando
    } = this.state;
    let habilitar_limpiar = accionProceso !== 'Tod_Ret' && accionProceso !== 'inicio'
    return (
      <>
        <Dialog fullWidth={true} maxWidth="sm" open={ModalAddFiltrosRetos} onClose={() => mostrarModalAddFiltrosRetos(false)} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <AppBarModal titulo='¡ Aplicar Filtros !' mostrarModal={mostrarModalAddFiltrosRetos} titulo_accion={ habilitar_limpiar ? "Limpiar" : ''} accion={habilitar_limpiar ? this.resetState : ''} />
          <DialogContent className='scroll'>
            {cargando ? <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true}/> :
              <Grid container spacing={3} className='margin_cont' >
                    <Grid item xs={12} xl={12} sm={12} md={12} lg={12} >
                      <BuscarSelect datos={periodos} cambiarEstado={(value) => this.setState({ periodo: value })} valor={periodo} id='select-periodo' nombre='Periodo' placeholder='Seleccione Periodo' />
                    </Grid>
                    <Grid item xs={12} xl={12} sm={12} md={12} lg={12} >
                      <BuscarSelect datos={estados} cambiarEstado={(value) => this.setState({ estado: value })} valor={estado} id='select-estado' nombre='Estados reto' placeholder='Seleccione estado' />
                    </Grid>
              </Grid>
            }
          </DialogContent>
          <DialogActions>
            <BtnForm texto="CANCELAR" callback={() => mostrarModalAddFiltrosRetos(false)} />
            {!cargando && <BtnForm texto="FILTRAR" callback={this.onSubmit} />}
          </DialogActions>
        </Dialog >
      </>
    )
  }
}

//Props del componente
RetoFiltrar.propTypes = {
  //variables
  ModalAddFiltrosRetos: PropTypes.bool.isRequired,
  //funciones
  mostrarModalAddFiltrosRetos: PropTypes.func.isRequired,
  filtrar: PropTypes.func.isRequired,
  limpiar: PropTypes.func.isRequired,
}
export default RetoFiltrar;
